

export const TRANCHE_AGE = [
  {
    value: 'A',
    min: 18,
    max: 25,
    text: 'Entre 18 ans et 25 ans'
  },
  {
    value: 'B',
    min: 25,
    max: 35,
    text: 'Entre 25 ans et 35 ans'
  },
  {
    value: 'C',
    min: 35,
    max: 45,
    text: 'Entre 35 ans et 45 ans'
  },
  {
    value: 'D',
    min: 45,
    max: 55,
    text: 'Entre 45 ans et 55 ans'
  },
  {
    value: 'E',
    min: 55,
    max: 65,
    text: 'Entre 55 ans et 65 ans'
  },
  {
    value: 'F',
    min: 65,
    max: 75,
    text: 'Entre 65 ans et 75 ans'
  },
  {
    value: 'M',
    min: 75,
    max: null,
    text: 'Plus de 75 ans'
  },
];

export const ITEM_TYPES = Object.freeze(
  {
    PRESTATION:
    {
      apiId: 'PRESTATION',
      storePath: 'prestation'
    },
    ENVIEMOMENT:
    {
      apiId: 'ENVIEMOMENT',
      storePath: 'enviemoment'
    },
    BONPLAN:
    {
      apiId: 'BONPLAN',
      storePath: 'bonPlan'
    },
    CATEGORIE:
    {
      apiId: 'CATEGORIE',
      storePath: 'categorie'
    },
    INSTITUT:
    {
      apiId: 'INSTITUT',
      storePath: 'institut'
    },
    MARQUE:
      {
        apiId: 'MARQUE',
        storePath: 'marque'
      },
    EMPLOYE:
    {
      apiId: 'PRATICIENNE',
      storePath: 'praticienne'
    }
  });

export const ROLES = Object.freeze({
  ADMIN: {
    API: 'ADMIN',
    label: 'Administrateur'
  },
  SUPERADMIN: {
    API: 'SUPERADMIN',
    label: 'Super administrateur'
  },
  MANAGER: {
    API: 'MANAGER',
    label: 'Gérant'
  },
  EMPLOYE: {
    API: 'EMPLOYE',
    label: 'Employé'
  },
  MARQUE: {
    API: 'MARQUE',
    label: 'Marketeur'
  }
});

export  const customToolbar = [
     ["bold", "italic"], // toggled buttons
  ];
export const SEXE = [{ text: '-- Femme --', value: 'F' }, { text: '-- Homme --', value: 'M' }, { text: '-- Indéfini --', value: null }];
export const UNIT = [{ text: '-------', value: null },{ text: '-- ml --', value: 'ml' }, { text: '-- g --', value: 'g' }];
export const NIVEAU = [{ text: '-- Phisique --', value: 'P' }, { text: '-- Mental --', value: 'M' }];
export const ACTIVATION = [{ text: '-- active --', value: 1 }, { text: '-- non active --', value: 0 }];
export const CREER_VIA = { creer_via: 'BO' };
export const PROVENANCE = [{ text: 'Tous', value: '' }, { text: 'Back-Office', value: 'BO' }, { text: 'Blinki', value: 'BLINKI' }, { text: 'MARKET', value: 'MARKET' }];
